var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "body" }, [
    _c("div", { staticClass: "close-btn", on: { click: _vm.close } }, [
      _c(
        "i",
        { staticClass: "material-icons md-18", attrs: { title: "close" } },
        [_vm._v("close")]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "title" }, [_vm._v("REMOVE SELECTED PARCELS")]),
    _vm._v(" "),
    _c("div", { staticClass: "p-3" }, [
      _c(
        "form",
        {
          staticClass: "category form-group",
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.formSubmit.apply(null, arguments)
            }
          }
        },
        [
          _c("div", { staticClass: "modal-property-row" }, [
            _vm._v(
              "\n\t\t\t\tAre you sure you would like to remove " +
                _vm._s(_vm.theseParcelsDisplay) +
                "?\n\t\t\t"
            )
          ]),
          _vm._v(" "),
          _vm._m(0)
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-actions" }, [
      _c(
        "button",
        { staticClass: "btn btn-dark float-right", attrs: { type: "submit" } },
        [_vm._v("Remove")]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-16ea9fc6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16ea9fc6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/collection/collection-remove-selected.vue
// module id = null
// module chunks = 